import { render, staticRenderFns } from "./training_questions.vue?vue&type=template&id=2c647b85"
import script from "./training_questions.vue?vue&type=script&lang=js"
export * from "./training_questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports